<template>
  <b-container fluid>
    <b-row no-gutters>
      <b-col cols="10">
        <b-row no-gutters>
          <span class="term">{{word.term}}</span>
          <span class="pronunciation">&#47;{{word.pronunciation}}&#47;</span>
        </b-row>
        <b-row no-gutters>
          <span class="translation">({{word.translation}})</span>
        </b-row>
        <b-row no-gutters>
          <span>{{word.exampleSentence}}</span>
        </b-row>
      </b-col>
      <b-col class="text-right" v-if="canDelete">
        <button class="btn btn-danger add-item" @click="$emit('onDelete')">Usuń</button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["word", "canDelete"]
};
</script>
<style lang="scss" scoped>
.term {
  font-weight: 600;
}
.pronunciation {
  font-style: italic;
  font-weight: 200;
  margin-left: 2rem;
}
</style>